module.exports = __webpack_public_path__ + "assets/img/SEA.1a7e02a0.png";